// extracted by mini-css-extract-plugin
module.exports = {"customImage":"style_customImage__rJ6SW"};